import React from "react";
import { BiMinus, BiPlus } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import { useDispatch } from "react-redux";
import {
  addToCart,
  removeFromCart,
  removeItemFromCart,
  removeOneQuantityFromCart,
} from "../../redux/features/cart/cartSlice";
// Import any functions like removeFromCart, decreaseCartQuantity, increamentCartQuantity if needed

const CartItem = ({ name, id, price, image, quantity }) => {
  const dispatch = useDispatch();

  const increamentHandler = () => {
    dispatch(
      addToCart({
        name,
        id,
        price,
        image,
        quantity: 1,
      })
    );
  };

  const decreamentHandler = () => {
    dispatch(removeOneQuantityFromCart(id));
  };

  return (
    <div className="flex justify-between items-center bg-slate-100 my-1 p-1 rounded relative min-w-[320px]">
      <div className="flex flex-1 items-center ">
        <img
          className="inline-block"
          src={`${image}`}
          height={50}
          width={50}
          alt="product image"
        />
        <div className=" text-sm mx-2 flex-1">
          <div className="flex flex-col md:flex-row md:justify-between items-center">
            <h1 className="text-slate-900 font-bold mx-5 line-clamp-1">
              {name}
            </h1>
            <div className=" flex items-center justify-center mt-2 md:mr-2  md:mt-0">
              <button onClick={increamentHandler}>
                <BiPlus className="text-lg text-green-500" />
              </button>
              <span className="border px-2 mx-1">{quantity}</span>
              <button onClick={decreamentHandler}>
                <BiMinus className="text-lg text-red-500" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center">
        <div className="prizeAndButton font-bold text-[#FF7A00] text-xl ">
          ৳ {price * quantity} {/* Update this line */}
        </div>

        <button
          onClick={() => {
            dispatch(removeItemFromCart(id));
          }}
        >
          <MdDelete className="ml-2 text-red-500" />
        </button>
      </div>
    </div>
  );
};

export default CartItem;
